import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["coApplicants"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import ConsolidatedRequestApplicationShared from "./consolidated-request-application-shared.vue";
import ConsolidatedRequestBankStatements from "./consolidated-request-bank-statements.vue";
import ConsolidatedRequestDocuments from "./consolidated-request-documents.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineConsolidatedRequest",
  components: {
    ConsolidatedRequestApplicationShared,
    ConsolidatedRequestDocuments,
    ConsolidatedRequestBankStatements
  },
  props: {
    metadata: {
      type: Object,
      default: () => ({})
    },
    expandOnInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMultiBorrowerRequest() {
      return !!this.metadata.fillOut;
    },
    hasBankStatementRequest() {
      return !isEmpty(this.bankStatements);
    },
    hasDocumentsRequest() {
      var _this$metadata$docume, _this$metadata$coAppl;
      return ((_this$metadata$docume = this.metadata.documentRequestIds) == null ? void 0 : _this$metadata$docume.length) > 0 || ((_this$metadata$coAppl = this.metadata.coApplicants) == null ? void 0 : _this$metadata$coAppl.some(({
        documentRequestIds
      }) => !isEmpty(documentRequestIds)));
    },
    hasApplicationShared() {
      return this.metadata.shared || !(this.hasBankStatementRequest || this.hasDocumentsRequest);
    },
    bankStatements() {
      var _this$metadata$bankSt, _this$metadata$bankSt2;
      if (Array.isArray(this.metadata.bankStatements) && this.metadata.bankStatements.length > 0) {
        return {
          emails: this.metadata.bankStatements,
          months: 12
        };
      }
      if (((_this$metadata$bankSt = this.metadata.bankStatements) == null ? void 0 : (_this$metadata$bankSt2 = _this$metadata$bankSt.emails) == null ? void 0 : _this$metadata$bankSt2.length) > 0) {
        return this.metadata.bankStatements.months ? this.metadata.bankStatements : {
          emails: this.metadata.bankStatements.emails,
          months: 12
        };
      }
      return null;
    },
    documentRequestIds() {
      return this.metadata.documentRequestIds;
    },
    requestedDocuments() {
      var _context;
      if (!this.isMultiBorrowerRequest) return [{
        quantity: this.metadata.documentRequestIds.length
      }];
      return _mapInstanceProperty(_context = this.sharedApplications).call(_context, ({
        email,
        alternateEmail,
        documentRequestIds
      }) => ({
        email: email || alternateEmail,
        quantity: documentRequestIds.length
      }));
    },
    sharedApplications() {
      if (!this.isMultiBorrowerRequest) return [];
      const _this$metadata = this.metadata,
        {
          coApplicants
        } = _this$metadata,
        mainApplicant = _objectWithoutProperties(_this$metadata, _excluded);
      return [mainApplicant, ...coApplicants];
    }
  }
});